import React, { useState } from "react";
import { useAppDispatch, useAppSelector } from "@/store/hooks";

import { sendSupportRequest } from "@/store/users";

import AppInput from "@/components/AppInput";
import AppButton from "@/components/AppButton";
import AppBox from "@/components/AppBox";

interface SendSupportModalProps {
  onClose: () => void;
}

const SendSupportModal: React.FC<SendSupportModalProps> = ({ onClose }) => {
  const dispatch = useAppDispatch();
  const { me } = useAppSelector((state: any) => state.auth);

  const [form, setForm] = useState({ message: "", subject: "" });

  const handleChange = (field: string, value: any) => {
      setForm((state) => ({
        ...state,
        [field]: value,
      }));
    };

  const handleSendRequest = async () => {
    await dispatch(sendSupportRequest(form));
    setForm({ message: "", subject: "" });
    onClose();
  };

  return (
    <AppBox column gap={4}>
      <AppInput
        type="text"
        label="Subject"
        fullWidth
        onChange={(value: any) => handleChange("subject", value)}
        value={form.subject}
      />

      <AppInput
        type="text"
        label="Message"
        fullWidth
        multiline
        rows={5}
        onChange={(value: any) => handleChange("message", value)}
        value={form.message}
      />

      <AppBox justify="center">
        <AppButton onClick={handleSendRequest}>Send</AppButton>
      </AppBox>
    </AppBox>
  );
};

export default SendSupportModal;